import React from "react";
import { Box, Image, Button, Stack } from "@chakra-ui/react";
import { Link } from "react-router-dom";
import HeroSection from "../components/herosection/HeroSection";
import forRentImg from "../images/for-rent.png";
import forSaleImg from "../images/for-sale.png";
import FeaturedSellers from "../components/featuredCommercial/featuredCommercial";
import FeaturedProperties from "../components/featuredProperties/featuredProperties";
import FeaturedCommercial from "../components/featuredCommercial/featuredCommercial";
import SellPropertySection from "../components/sellPropertySection/SellPropertySection";
import AboutUsSection from "../components/aboutUs/AboutUs";
import AvailablePropertyTypes from "../components/propertyTypes/PropertyTypes";
import AnimatedGradientLine from "../components/animatedLine/AnimatedLine";
import SellImage from "../images/featured.png";
import InvestmentImage from "../images/book.png";
import FeaturedSellerImage from "../images/featured_seller.png";
import BeFeaturedSeller from "../components/beFeaturedSeller/beFeaturedSeller";
import AdBanner from "../components/adBanner/AdBanner";
import saleImage from "../images/sale.png";
import rentImage from "../images/rent.png";
import investmentImage from "../images/investment.jpg";
import InteriorDesignAndConstruction from "../components/interiorDesignAndConstruction/InteriorDesignAndConstruction";
import Projects from "../components/projects/Projects";
import { projectsData } from "../data/companiesData";
import partnerImage from "../images/create-agency.png";
import YoutubeCarousel from "../components/youtubeCarousel/YoutubeCarousel";

const Home = () => {
  const property = {
    imageUrl: "",
    imageAlt: "Image",
  };
  return (
    <>
      <HeroSection />
      <div className="my-[5%]">
        <FeaturedProperties />
      </div>

      <YoutubeCarousel />

      {/* New Partner Section with Image */}
      <section className="py-12 bg-gradient-to-br from-green-50 to-white">
        <div className="container mx-auto px-6">
          <Box textAlign="center" mb={10}>
            <Box
              as="h2"
              fontSize={["2xl", "3xl", "4xl"]}
              fontWeight="bold"
              letterSpacing="tight"
              color="green.700"
              mb={3}
              textShadow="0 2px 8px rgba(0,0,0,0.08)"
            >
              Be Our Partner, Create Your Agency Profile
            </Box>
            <Box
              w={20}
              h={1}
              bgGradient="linear(to-r, green.400, green.600)"
              mx="auto"
              borderRadius="full"
              mb={4}
            />
            <p className="text-gray-600 max-w-2xl mx-auto text-lg">
              Join our network of trusted real estate agencies. Create your
              profile, showcase your listings, and connect with thousands of
              potential clients.
            </p>
          </Box>

          <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
            {/* Left Column - Image */}
            <div className="md:col-span-1 flex items-center justify-center">
              <div className="w-full max-w-sm rounded-2xl overflow-hidden shadow-lg bg-white">
                <img
                  src={partnerImage}
                  alt="Create your agency profile"
                  className="w-full h-auto object-cover"
                />
              </div>
            </div>

            {/* Middle Column - Benefits */}
            <div className="md:col-span-1 bg-white p-8 rounded-2xl shadow-lg border border-green-100 hover:shadow-xl transition-shadow duration-300">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <svg
                    className="w-6 h-6 text-green-600"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
                    />
                  </svg>
                </div>
                <h3 className="text-xl font-bold text-green-800">
                  Why Partner With Us?
                </h3>
              </div>
              <ul className="space-y-3 text-gray-700">
                <li className="flex items-start gap-3">
                  <span className="text-green-500 font-bold text-xl flex-shrink-0">
                    ✓
                  </span>
                  <span>
                    Get your agency featured on our platform with a dedicated
                    profile page
                  </span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-green-500 font-bold text-xl flex-shrink-0">
                    ✓
                  </span>
                  <span>
                    Showcase your properties to a targeted audience of buyers
                    and investors
                  </span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-green-500 font-bold text-xl flex-shrink-0">
                    ✓
                  </span>
                  <span>
                    Receive qualified leads directly through your profile
                  </span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-green-500 font-bold text-xl flex-shrink-0">
                    ✓
                  </span>
                  <span>
                    Access to our marketing tools and analytics dashboard
                  </span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-green-500 font-bold text-xl flex-shrink-0">
                    ✓
                  </span>
                  <span>
                    Priority placement in search results and category listings
                  </span>
                </li>
              </ul>
            </div>

            {/* Right Column - CTA */}
            <div className="md:col-span-1 bg-gradient-to-br from-green-600 to-green-700 p-8 rounded-2xl shadow-lg text-white flex flex-col justify-center">
              <div className="text-center">
                <div className="w-20 h-20 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-6">
                  <svg
                    className="w-10 h-10 text-white"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
                    />
                  </svg>
                </div>
                <h3 className="text-2xl font-bold mb-3">
                  Ready to Get Started?
                </h3>
                <p className="text-green-100 mb-6">
                  Create your agency profile today and start reaching more
                  clients through our platform.
                </p>
                <Link to="/register-agency">
                  <Button
                    size="lg"
                    bg="white"
                    color="green.700"
                    _hover={{ bg: "green.50", transform: "scale(1.02)" }}
                    _active={{ transform: "scale(0.98)" }}
                    px={8}
                    py={6}
                    fontSize="md"
                    fontWeight="bold"
                    rounded="xl"
                    boxShadow="lg"
                    transition="all 0.3s"
                    w="full"
                  >
                    Create Agency Profile
                    <svg
                      className="w-5 h-5 ml-2"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M13 7l5 5m0 0l-5 5m5-5H6"
                      />
                    </svg>
                  </Button>
                </Link>
                <p className="text-green-200 text-sm mt-4">
                  ✦ No setup fees • Quick approval • Start in minutes
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <AnimatedGradientLine />
      <Projects projects={projectsData} />
      <AnimatedGradientLine />
      <FeaturedSellers />
      <AnimatedGradientLine />
      <InteriorDesignAndConstruction />
      <SellPropertySection />
      <BeFeaturedSeller />
      <Stack
        direction={["column", "row"]}
        spacing="8"
        align="center"
        justify="center"
        mt="12"
        px="4"
      >
        <Box w="full" mb={8}>
          <Box textAlign="center" mb={6}>
            <Box
              as="h2"
              fontSize={["2xl", "3xl", "4xl"]}
              fontWeight="bold"
              letterSpacing="tight"
              color="green.700"
              mb={2}
              textShadow="0 2px 8px rgba(0,0,0,0.08)"
            >
              Explore Properties
            </Box>
            <Box
              w={16}
              h={1}
              bgGradient="linear(to-r, green.400, green.600)"
              mx="auto"
              borderRadius="full"
            />
          </Box>
          <Stack
            direction={["column", "row"]}
            spacing={[6, 8, 10]}
            align="center"
            justify="center"
            px={[2, 4, 8]}
          >
            {/* Properties For Sale Card */}
            <Box
              maxW="xs"
              w="full"
              rounded="xl"
              overflow="hidden"
              boxShadow="lg"
              borderWidth="1px"
              borderColor="gray.200"
              transition="box-shadow 0.3s"
              _hover={{ boxShadow: "xl" }}
              bg="white"
              p={4}
            >
              <Box pos="relative" h="40" overflow="hidden" mb={3}>
                <Image
                  className="rounded-md"
                  src={saleImage}
                  alt="Properties for sale"
                  w="full"
                  h="full"
                  objectFit="cover"
                  transition="transform 0.5s"
                  _hover={{ transform: "scale(1.05)" }}
                />
                <Box
                  pos="absolute"
                  inset={0}
                  bgGradient="linear(to-t, blackAlpha.700, transparent)"
                />
              </Box>
              <Box px={1}>
                <Box fontWeight="bold" fontSize="lg" mb={2} color="gray.800">
                  Properties For Sale
                </Box>
                <Link to="/category/sale">
                  <Button
                    w="full"
                    colorScheme="green"
                    leftIcon={
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path
                          fillRule="evenodd"
                          d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                          clipRule="evenodd"
                        />
                      </svg>
                    }
                    fontWeight="medium"
                    py={2}
                    fontSize="sm"
                    rounded="lg"
                    mt={2}
                  >
                    Browse Properties
                  </Button>
                </Link>
              </Box>
            </Box>

            {/* Investment Opportunities Card */}
            <Box
              maxW="xs"
              w="full"
              rounded="xl"
              overflow="hidden"
              boxShadow="lg"
              borderWidth="1px"
              borderColor="gray.200"
              transition="box-shadow 0.3s"
              _hover={{ boxShadow: "xl" }}
              bg="white"
              p={4}
            >
              <Box pos="relative" h="40" overflow="hidden" mb={3}>
                <Image
                  className="rounded-md"
                  src={investmentImage}
                  alt="Investment opportunities"
                  w="full"
                  h="full"
                  objectFit="cover"
                  transition="transform 0.5s"
                  _hover={{ transform: "scale(1.05)" }}
                />
                <Box
                  pos="absolute"
                  inset={0}
                  bgGradient="linear(to-t, blackAlpha.700, transparent)"
                />
              </Box>
              <Box px={1}>
                <Box fontWeight="bold" fontSize="lg" mb={2} color="gray.800">
                  Investment Opportunities
                </Box>
                <Link to="projects">
                  <Button
                    w="full"
                    colorScheme="green"
                    leftIcon={
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path d="M4 4a2 2 0 00-2 2v1h16V6a2 2 0 00-2-2H4z" />
                        <path
                          fillRule="evenodd"
                          d="M18 9H2v5a2 2 0 002 2h12a2 2 0 002-2V9zM4 13a1 1 0 011-1h1a1 1 0 110 2H5a1 1 0 01-1-1zm5-1a1 1 0 100 2h1a1 1 0 100-2H9z"
                          clipRule="evenodd"
                        />
                      </svg>
                    }
                    fontWeight="medium"
                    py={2}
                    fontSize="sm"
                    rounded="lg"
                    mt={2}
                  >
                    View Investments
                  </Button>
                </Link>
              </Box>
            </Box>

            {/* Properties For Rent Card */}
            <Box
              maxW="xs"
              w="full"
              rounded="xl"
              overflow="hidden"
              boxShadow="lg"
              borderWidth="1px"
              borderColor="gray.200"
              transition="box-shadow 0.3s"
              _hover={{ boxShadow: "xl" }}
              bg="white"
              p={4}
            >
              <Box pos="relative" h="40" overflow="hidden" mb={3}>
                <Image
                  className="rounded-md"
                  src={rentImage}
                  alt="Properties for rent"
                  w="full"
                  h="full"
                  objectFit="cover"
                  transition="transform 0.5s"
                  _hover={{ transform: "scale(1.05)" }}
                />
                <Box
                  pos="absolute"
                  inset={0}
                  bgGradient="linear(to-t, blackAlpha.700, transparent)"
                />
              </Box>
              <Box px={1}>
                <Box fontWeight="bold" fontSize="lg" mb={2} color="gray.800">
                  Properties For Rent
                </Box>
                <Link to="/category/rent">
                  <Button
                    w="full"
                    colorScheme="green"
                    leftIcon={
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z" />
                      </svg>
                    }
                    fontWeight="medium"
                    py={2}
                    fontSize="sm"
                    rounded="lg"
                    mt={2}
                  >
                    Find Rentals
                  </Button>
                </Link>
              </Box>
            </Box>
          </Stack>
        </Box>
      </Stack>

      <AboutUsSection />

      {/* Services Section - Fixed aspect ratios */}
      <section id="services" className="bg-white py-12">
        <div className="container mx-auto px-6">
          <h1 className="text-4xl text-center font-bold mb-6 text-green-800">
            Our Services
          </h1>
          <div className="grid md:grid-cols-3 gap-6 mt-6">
            <div className="bg-green-50 p-6 rounded-lg shadow-md border border-green-100 flex flex-col h-full">
              <div className="w-full aspect-[4/3] rounded-lg mb-5 shadow-md overflow-hidden bg-gray-200">
                <img
                  src={FeaturedSellerImage}
                  alt="Property agent services"
                  className="w-full h-full object-cover"
                />
              </div>
              <h4 className="text-lg font-semibold text-green-700">
                Agent Listings Management
              </h4>
              <p className="text-gray-600 mt-2 flex-grow">
                Be our Featured Agent and have our back in managing everything
                for you from creating your profile, uploading and managing your
                property listings to handling clients for you.
              </p>
            </div>
            <div className="bg-green-50 p-6 rounded-lg shadow-md border border-green-100 flex flex-col h-full">
              <div className="w-full aspect-[4/3] rounded-lg mb-5 shadow-md overflow-hidden bg-gray-200">
                <img
                  src={SellImage}
                  alt="Sell your property"
                  className="w-full h-full object-cover"
                />
              </div>
              <h4 className="text-lg font-semibold text-green-700">
                Sell Your Property with Us
              </h4>
              <p className="text-gray-600 mt-2 flex-grow">
                Have our back to list your property on our front page and on top
                of other listings. This will help buyers to find you easily and
                help you sell your property within days of listing.
              </p>
            </div>
            <div className="bg-green-50 p-6 rounded-lg shadow-md border border-green-100 flex flex-col h-full">
              <div className="w-full aspect-[4/3] rounded-lg mb-5 shadow-md overflow-hidden bg-gray-200">
                <img
                  src={InvestmentImage}
                  alt="Real estate investment"
                  className="w-full h-full object-cover"
                />
              </div>
              <h4 className="text-lg font-semibold text-green-700">
                Real Estate Investment
              </h4>
              <p className="text-gray-600 mt-2 flex-grow">
                Enhance your investment portfolio with premium real estate
                opportunities. Find lucrative properties and get expert guidance
                to maximize your returns in the property market.
              </p>
            </div>
          </div>
        </div>
      </section>

      <AvailablePropertyTypes />
      {/* <AdSenseAd client="ca-pub-8548134289451448" slot="2500951548" /> */}
    </>
  );
};

export default Home;
